import classNames from 'classnames';
import Surface from 'components/Surface';
import Trap from 'components/Trap';
import React, { Component } from 'react';
import ReactModal from 'react-modal';
import type { Merge } from 'types/utility';
import styles from './SuperModal.module.scss';

// Required to "hide" rest of app from screenreaders when modal is open
if (document.getElementById('app')) {
  ReactModal.setAppElement('#app');
} else if (document.getElementById('public-app')) {
  ReactModal.setAppElement('#public-app');
} else if (document.getElementById('root')) {
  ReactModal.setAppElement('#root');
}

interface OwnProps {
  /** Contents of modal */
  children: React.ReactNode;
  /** Function that will be run when the modal is requested to be closed (either by clicking on overlay or pressing ESC). Note: It is not called if isOpen is changed by other means. */
  onClose?: () => void; // Alias of onRequestClose,
  /** Function that will be run after the modal has opened. */
  onOpen?: () => void; // alias of onAfterOpen,
  style?: {
    content?: {
      [key: string]: string | number;
    };
    overlay?: {
      [key: string]: string | number;
    };
  };
  /** Should the modal always overlay Navbar? */
  alwaysOverlayNavbar?: boolean;
  /** Can the modal overlay Navbar on smaller viewports? See $modalOverlaysNavbarBelowPx (variables.scsss) */
  allowOverlayNavbar?: boolean;
  /* String className to be applied to the inner modal content.*/
  className?: string;
  /* To be applied to the modal wrapper */
  modalClassName?: string;
  surfaceClassName?: string;
  /* Boolean indicating if the overlay should close the modal */
  shouldCloseOnOverlayClick?: boolean;
  /*  Boolean describing if the modal should be shown or not. */
  isOpen: boolean;
  zIndex?: number;
}

export type Props = Merge<ReactModal.Props, OwnProps>;

class SuperModal extends Component<Props> {
  static defaultProps = {
    modalClassName: styles.modal,
    allowOverlayNavbar: false,
    style: {
      content: {},
      overlay: {},
    },
  };
  render() {
    const {
      children,
      className,
      modalClassName,
      overlayClassName,
      allowOverlayNavbar,
      alwaysOverlayNavbar,
      onOpen,
      onClose,
      // Trap takes ownership of these, don't pass to ReactModal
      // in attempt to control ESC behavior better
      shouldCloseOnOverlayClick,
      shouldCloseOnEsc,
      zIndex,
      style,
      surfaceClassName,
      ...rest
    } = this.props;

    const modalProps = {
      style: {
        content: {
          zIndex,
          ...style?.content,
        },
        overlay: {
          zIndex: zIndex ? zIndex + 1 : undefined,
          ...style?.overlay,
        },
      },
      overlayClassName: classNames(
        styles.backdrop,
        {
          [styles.allowOverlayNavbar]: allowOverlayNavbar,
          [styles.alwaysOverlayNavbar]: alwaysOverlayNavbar,
        },
        typeof overlayClassName === 'string' ? overlayClassName : undefined
      ),
      className: modalClassName,
      ...rest,
      // Aliasing props to stay consistent
      onAfterOpen: onOpen,
      // <Trap /> deal with these instead
      // We might want to remove the ReactModal dependency?
      shouldCloseOnEsc: false,
      shouldCloseOnOverlayClick: false,
    };

    return (
      <ReactModal {...modalProps}>
        {/* Only renders when props.isOpen */}
        <Trap
          className={className}
          shouldExitOnClickOutside={shouldCloseOnOverlayClick}
          shouldExitOnEsc={shouldCloseOnEsc}
          onExit={onClose}
          enabled={!!onClose}
        >
          <Surface className={classNames(styles.surface, surfaceClassName)}>{children}</Surface>
        </Trap>
      </ReactModal>
    );
  }
}

export default SuperModal;
